/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import {createRoot} from 'react-dom/client';
import Select, { components } from 'react-select';
import SelectorBadge from './SelectorBadge.jsx';
import Skeleton from '@mui/material/Skeleton';
import styled from 'styled-components';

const Wrapper = styled.div`
    .form-group-hotels-groups-selector {
        .hotels-groups-selector-wrapper {
            position: relative !important;
            padding-top: .42rem;
            padding-bottom: .38rem;

            .selected {
                display: flex;
                flex-wrap: wrap;
                padding: .4rem 2rem .5rem .8rem;
                :not(.hotels-groups):hover {
                    cursor: pointer;
                }
            }

            .react-select__indicators:hover {
                cursor: pointer;
            }
        }

        .btn-select {
            position: absolute;
            top: 0.5rem;
            right: -0.1rem;
            background: none !important;
            border: none !important;
        }

        .badge {
            display: inline-block; 
            margin-right: .4rem !important;
        }
    }
`;

const { Option } = components;
const IconOption = (props) => {
    let classLabel = '';
    let icon = null;
    switch (props.data.type) {
        case 'group':
            classLabel += 'font-weight-bold';
            if (props.data.disabled) {
                classLabel += ' text-muted';
            } else {
                icon = <i className='fa-sharp fa-regular fa-buildings mr-1'></i>
            }
            break;
        default:
            if (props.data.hotels_active_forms_requests && props.data.hotels_active_forms_requests == 0) {
                icon = <i className='fa-light fa-ban text-danger ml-2 mr-1'></i>;
            } else {
                classLabel += 'ml-2';
            }
    }

    return (
        <Option className='py-1' {...props}>
            {icon}
            <span className={classLabel}>
                {props.data.label}
            </span>
        </Option>
    )
};

export default class HotelsGroupsSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            choicesLoader: false,
            display_select: false,
            hotels_by_groups: [],
            selection: []
        };

        this.selectStyles = {
            menu: base => ({
                ...base,
                marginTop: 3,
                zIndex: 10,
                fontSize: '.9em'
            })
        }
    }

    componentDidMount() {
        let url = ENV.base_lang_url + "myspace/providers//hotels/ajax/get_hotels_by_groups";
        fetch(url)
        .then(rtn => rtn.json())
        .then(result => {
            const hotels_by_groups = result.hotels_by_groups;
            if (hotels_by_groups) {
                this.setState({
                    hotels_by_groups: hotels_by_groups,
                    isLoaded: true
                });
                this.setDefaultValues(hotels_by_groups);
            }
        })
        .catch(error => { 
            this.setState({
                isLoaded: false,
                error
            });
        });
    }

    setDefaultValues(hotels_by_groups = []) {
        if (this.props.values.length > 0) {
            let default_values = hotels_by_groups.filter((item) => {
                return this.props.values.includes(item.value);
            });
            this.setState({
                selection: default_values
            });
        }
    }

    handleChange(event) {
        if (event) {
            this.setState({
                display_select: false,
                choicesLoader: true
            });

            let result = [];
            let selection = this.state.selection;
            let all_hotels_societe = [];
            let all_hotels_groups = [];
            this.state.hotels_by_groups.map((item) => (
                item.type === 'hotel' ? all_hotels_societe.push(item) : all_hotels_groups.push(item)
            ))
            all_hotels_societe.map((item) => {
                if (event.value === item.value) {
                    this.state.hotels_by_groups.map((el) => {
                        if (el.type === 'group' && el.value === 'g_' + item.hotels_groups_id) {
                            result.push(el);
                        }
                    })
                }
            });
            all_hotels_groups.map((item) => {
                if (event.value === item.value) {
                    this.state.hotels_by_groups.map((el) => {
                        if (el.type === 'hotel' && el.hotels_groups_id === item.hotels_groups_id) {
                            result.push(el);
                        }
                    })
                }
            });

            selection = selection.concat(event);
            selection = [
                ...new Map(selection.map((item) => [item.value, item])).values()
            ];
            if (result.length > 0) {
                selection = selection.filter((item) => !result.includes(item));
            }

            this.setState({
                selection,
                choicesLoader: false
            });
        }
    }

    handleRemove = (value) => {
        let selection = this.state.selection;
        selection = selection.filter((item) => {
            return item.value != value;
        });
        this.setState({
            selection: selection
        });
    }

    handleClickDisplaySelect = () => {
        this.setState({
            display_select: true
        });
    };

    handleCloseSelect = () => {
        this.setState({
            display_select: false
        });
    };

    DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <i className='fa-thin fa-xmark px-1' onClick={() => this.handleCloseSelect()}></i>
        </components.DropdownIndicator>
    );

    render() {
        let required_attributes = {};
        if (this.props.required) {
            required_attributes['data-parsley-validate-if-empty'] = true;
            required_attributes['data-parsley-min'] = 1;
            required_attributes['data-parsley-error-message'] = this.props.trad.required_error_message;
        }

        return (
            <Wrapper id='react-hotels-groups-selector'>
                { !this.state.isLoaded ? (
                    <Skeleton className="form-group" variant="rectangular" width="100%" height={89} />
                ) : (
                    <div className='form-group form-group-hotels-groups-selector'>
                        { this.props.label && (
                            <label>{this.props.label}</label>
                        )}
                        <div className='hotels-groups-selector-wrapper'>
                            { !this.state.display_select && (
                                <div 
                                    className={this.state.selection.length > 0 ? 'selected hotels-groups' : 'selected'}
                                    onClick={() => (this.state.selection.length === 0 ? this.handleClickDisplaySelect() : false)}
                                >
                                    { this.state.selection.length > 0 ? (
                                        this.state.selection.map((item, index) => {
                                            let icon = <i className='fa-sharp fa-regular fa-buildings mr-1'></i>;
                                            if (item.type === 'hotel') {
                                                icon = <i className='fa-light fa-hotel mr-1'></i>;
                                                if (item.hotels_active_forms_requests && item.hotels_active_forms_requests == 0) {
                                                    icon = <i className='fa-light fa-ban text-danger mr-1'></i>;
                                                }
                                            }
                                            return (
                                                <SelectorBadge 
                                                    key={index}
                                                    inputName={this.props.name}
                                                    inputValue={item.value}
                                                    icon={icon}
                                                    text={item.label}
                                                    handleRemove={this.handleRemove}
                                                    bgColor={item.type === 'hotel' ? 'light' : 'gc-light-blue-dark'}
                                                />
                                            )
                                        })
                                    ) : (
                                        <span className="text-gc-orange font-weight-bold">
                                            { this.props.trad.placeholder }
                                        </span>
                                    )}

                                    <input
                                        type="hidden"
                                        value={this.state.selection.length}
                                        required={true}
                                        {...required_attributes}
                                    />

                                    <div className="flex-grow-1 pe-auto" role="button" onClick={() => this.handleClickDisplaySelect()} />

                                </div>
                            )}

                            <button 
                                type='button' 
                                className='btn btn-select dropdown-toggle text-gc-orange'
                                role='button'
                                aria-expanded='false'
                                onClick={() => this.handleClickDisplaySelect()}
                            >
                            </button>

                            { this.state.display_select && (
                                <Select 
                                    autoFocus
                                    options={this.state.hotels_by_groups}
                                    value={null}
                                    menuIsOpen={this.state.display_select}
                                    onChange={(e) => this.handleChange(e) }
                                    onBlur={() => this.handleCloseSelect()}
                                    components={{ Option: IconOption, DropdownIndicator: this.DropdownIndicator }}
                                    placeholder={`${ this.props.trad.placeholder_recherche }...`}
                                    noOptionsMessage={() => this.props.trad.aucun_resultat }
                                    classNamePrefix='react-select'
                                    styles={this.selectStyles}
                                    isOptionDisabled={(option) => option.disabled}
                                />
                            )}
                        </div>
                    </div>
                )}
            </Wrapper>
        );
    }
}